import ForgottenPasswordForm from "./ForgottenPasswordForm";

export default ForgottenPasswordForm;
